module.exports = __webpack_public_path__ + "static/media/jianti.f49ff026.png";